module.exports = "mutation DeleteStoreContact($id:ID!){deleteStoreContact(id:$id){success}}"